import axios from 'axios';
import { msalInstance } from './authConfig';
import { useStoreUser } from "@/stores/userStore";
import router from "@/router";
import { toast } from "vue3-toastify";


// old const apiBase =   import.meta.env.DEV  ? '/api' : import.meta.env.VITE_API_BASE_URL;

// Create Axios instance with dynamic baseURL
export const msalApi = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    withCredentials: true,
});

export async function setupAxiosInterceptors() {
    const userStore = useStoreUser();

    // Request Interceptor
    msalApi.interceptors.request.use(
        async (config) => {
            // Remove '/api' prefix from the request URL if present
            if (config.url && config.url.startsWith('/api/')) {
                config.url = config.url.replace(/^\/api/, '');
            }

            // Token handling (unchanged)
            if (userStore.accessToken != null && userStore.accessToken.trim() !== "") {
                localStorage.setItem("accessToken", userStore.accessToken);
            } else {
                const storedToken = localStorage.getItem("accessToken");
                if (storedToken && storedToken.trim() !== "") {
                    userStore.accessToken = storedToken;
                }
            }

            if (userStore.accessToken && config.headers) {
                config.headers['Authorization'] = `Bearer ${userStore.accessToken}`;
                config.headers['Content-Type'] = 'application/json';
            }
            return config;
        },
        (err) => Promise.reject(err)
    );

    // Response Interceptor (unchanged)
    msalApi.interceptors.response.use(
        (response) => response,
        async (err) => {
            const { response } = err;
            if (!response) {
                toast.error("Network error. Try refreshing your browser or logging back in.");
                return Promise.reject(err);
            }
            const { status } = response;
            if (response && response.status === 401 && !err.config._retry) {
                err.config._retry = true;
                try {
                    const accounts = await msalInstance.getAllAccounts();
                    if (accounts.length > 0) {
                        const result = await msalInstance.acquireTokenSilent({
                            account: accounts[0],
                            scopes: [import.meta.env.VITE_API_SCOPE],
                        });
                        const userStore = useStoreUser();
                        userStore.accessToken = result.accessToken;
                        localStorage.setItem("accessToken", result.accessToken);
                        err.config.headers = err.config.headers || {};
                        err.config.headers.Authorization = `Bearer ${result.accessToken}`;
                        return msalApi.request(err.config);
                    } else {
                        router.push("/login");
                    }
                } catch (refreshError) {
                    // Optionally handle refresh error
                }
            }
            if (status === 403) {
                toast.error("You are unauthorized to access this resource.");
            }
            if (status === 302) {
                toast.error("Session expired. Please refresh your browser to re-login.");
            }
            if (status >= 500 && status < 600) {
                toast.error(`Server error: ${status}. Please contact support.`);
            }
            return Promise.reject(err);
        }
    );
}

export default msalApi;
